<hlm-dialog-header>
  <h3 class="paragraph-large-medium" hlmDialogTitle>{{ titre }}</h3>
</hlm-dialog-header>
<div class="paragraph-large-medium px-md pt-md" [innerHTML]="contenu"></div>
@if (messageAlerte) {
  <div class="paragraph-large-medium p-md" [innerHTML]="messageAlerte"></div>
}
<hlm-dialog-footer class="p-md flex w-full justify-between">
  <button brnDialogClose hlmBtn variant="secondary" type="button">
    <ng-icon name="lucideX" />
    Annuler
  </button>
  <button (click)="close(true)" hlmBtn>
    <ng-icon name="lucideCheck" />
    {{ confirmText }}
  </button>
</hlm-dialog-footer>
